// import axios from 'axios'

// 本地请求地址
// export const urls = 'http://localhost:13000' // 本地

// export const urls = 'http://192.168.0.39:12000' // 本地
// export const urls = 'http://192.168.1.5:12000' // 本地
// export const urls = 'http://www.eco-earth.cc:43065' // 正式np,
export const urls = 'https://www.eco-earth.cc:43058' // 正式np,

export {}
